import { render, staticRenderFns } from "./AppHeaderComponent.vue?vue&type=template&id=72350f03"
import script from "./AppHeaderComponent.vue?vue&type=script&lang=js"
export * from "./AppHeaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports